


















import { Component, Vue, Prop } from "vue-property-decorator";
// @ts-ignore
import VClamp from "vue-clamp";

@Component({
    components: {
        VClamp
    }
})
export default class BlogCard extends Vue {
    @Prop({ required: true }) article!: Article;

    @Prop({ default: 343 }) imageHeight?: number | "auto";

    @Prop({ default: true }) clamp?: boolean;

    get articleTilte() {
        if (this.article.title) {
            return this.article.title.rendered;
        }
        if (this.article.post_title) {
            return this.article.post_title;
        }

        return "";
    }
}
